import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

import TableRow from './TableRow';

const AlertTypeRow = () => (
    <TableRow
        browser={
            <StyledCaption>
                <FormattedMessage id="notificationsPage.table.header.browserAlert" />
            </StyledCaption>
        }
        email={
            <StyledCaption>
                <FormattedMessage id="notificationsPage.table.header.emailAlert" />
            </StyledCaption>
        }
        sms={
            <StyledCaption>
                <FormattedMessage id="notificationsPage.table.header.smsAlert" />
            </StyledCaption>
        }
        type={
            <StyledCaption>
                <FormattedMessage id="notificationsPage.table.header.type" />
            </StyledCaption>
        }
    />
);

export default AlertTypeRow;

const StyledCaption = styled(Caption)`
    text-transform: uppercase;
`;
